module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.fee66e7.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 371
// module chunks = 4